<template>
    <div class="hamburger hamburger--spin" :class="rootClasses" @click.stop="toggle({ isOpen: !isOpen })">
        <span class="hamburger-box">
            <span class="hamburger-inner"/>
        </span>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        mixins: [
            bemMixin('hamburger'),
        ],
        computed: {
            ...mapState('side-navigation', ['isOpen']),
            rootClasses() {
                return [
                    // notice that the hamburger library is not BEM compatible that's why we need the class below
                    this.isOpen ? 'is-active' : null,
                    // normal facets as always
                    this.bemIf(this.isOpen, 'is-active'),
                    ...this.bemFacets,
                ];
            },
        },
        methods: {
            ...mapActions('side-navigation', ['toggle']),
        },
    };
</script>
